<template>
  <div id="top">
      <b-container fluid style="padding-top: 100px;">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
      <b-row>
          <b-col cols="12" >
            <b-breadcrumb style="    background-color: #e9ecef78;">

                <b-breadcrumb-item href="#home">
                  <router-link to="/">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                    Home
                    </router-link>
                </b-breadcrumb-item>

               <b-breadcrumb-item href="#" active>Associated Sites</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <AssociatedSitesCardComponents/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
  import AssociatedSitesCardComponents from '@/components/AssociatedSitesCardComponents.vue'
  import HeaderFixed from '@/components/HeaderFixed.vue'
  import HeaderMobile from '@/components/HeaderMobile.vue'


  export default {
    name: 'AssociatedSites',
    components: {
      'AssociatedSitesCardComponents' : AssociatedSitesCardComponents,
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
    },
    mounted()
    {
      document.getElementById("top").scrollIntoView({  behavior: 'smooth', block: 'start', inline: 'start'  });
    }
  }
</script>
<style>
.headerF{
  display: block;
}
.headerM{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }
</style>
